import React from 'react';
import List from '../components/List';
import ContentPlayer from '../components/ContentPlayer';
import Loader from '../components/Loader'
import MainLogo from '../components/MainLogo';
import PlayerList from '../components/PlayerListe';
import ShareAlternative from '../components/ShareAlternative';

import {encode, decode} from '../utils/ListEncoder'
import PlaybackEngine from '../api/PlaybackEngine'

import canAutoPlay from 'can-autoplay';

class Player extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      json: this.props.json,
      query: this.props.query,
      loaded:false,
      videoPlaying:false,
      progress:0,
      choosenItems:[],
      showingList : false,
      canAutoPlay : false,
      shareAlternative : false,
      isMuted : false
    }

    this.onReady = this.onReady.bind(this);
    this.onLoading = this.onLoading.bind(this);
    this.onStopped = this.onStopped.bind(this);
    this.onLoaded = this.onLoaded.bind(this);
    this.soundAdded = this.soundAdded.bind(this);
    this.onProgress = this.onProgress.bind(this);
    this.onFinished = this.onFinished.bind(this);

    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);

    this.openList = this.openList.bind(this);
    this.closeList = this.closeList.bind(this);

    this.shareAlternative = this.shareAlternative.bind(this);
    this.closeShareAlternative = this.closeShareAlternative.bind(this);

    this.handleMute = this.handleMute.bind(this);
    this.handleBack = this.handleBack.bind(this);

    this.engine = new PlaybackEngine(this.props.json, {
      onReady : this.onReady,
      onLoading : this.onLoading,
      onPlaying : this.onPlaying,
      onStopped : this.onStopped,
      onProgress : this.onProgress,
      onFinished : this.onFinished
    });
}

componentDidMount(){

  window.dataLayer.push({
  event: 'virtualPageview',
  page: {
    path: '/video',
    title: 'Video'
    }
  });

  canAutoPlay
      .video({timeout: 400, muted: true, inline : true})
      .then(({result, error}) => {
          if(result === false){
          console.log("canAutoplayFalse", result, error);
          }else{
          console.log("canAutoplayTrue", result, error);
              this.setState({canAutoPlay : true})
          }
      })

  let query = this.props.query.location.search.substring(1)
  console.log("query");

  let items = decode(query);

  items.forEach((itemId, i) => {

      let indexPos = this.props.json.findIndex(x => x.id === itemId);
      if(indexPos >= 0){
        this.soundAdded(indexPos,this.props.json[indexPos])
        console.log("soundAdded");
      }

  });

  if(this.props.firstTime){
    //Insert google analytics stuff here
    this.props.updateFirstTime(false);
  }

}

componentWillUnmount(){
  //console.log("unmount");
  this.engine.stop();
}


onReady(){
console.log("ready!!!");
if(!this.state.loaded){

  console.log('ready!')
  setTimeout(function() { //Start the timer
    this.setState({ loaded: true })

    let canAudioPlay = this.engine.audioContext.state == "running"
    let canVideoPlay = this.state.canAutoPlay;

    //we're golden and everything is rainbows
    if(canAudioPlay && canVideoPlay){
    //  console.log("onReady video playing");
      this.setState({ videoPlaying:true })
    }

  }.bind(this), 1000)
}
}


onLoading(){
  //console.log("loading!")
}



onStopped(){
  if(this.state.videoPlaying)
    this.setState({videoPlaying:false})
}



soundAdded(index, item) {
  this.engine.stop()

  this.state.choosenItems.push({ index, item, loaded: false });
  let list = this.state.choosenItems.map((item) => {
    return item.index;
  })

  this.engine.setList(list);
  this.setState({ choosenItems: this.state.choosenItems }, () => {

   // this.addSelectionToNav();

  });
}

onLoaded(){

}

onProgress(progress){
  this.setState({progress})
}

onFinished(){
  this.setState({progress : 1});
}

handlePause(){
  this.setState({videoPlaying : false});
  this.engine.pause()

  window.dataLayer.push({
    eventCategory: 'video',
    eventAction: 'clicVideo',
    eventLabel: 'arretVideo',
    event: 'genericGAEvent'
  });
}

handlePlay(){
  this.setState({videoPlaying : true});
  this.engine.play();

  if(!this.state.videoPlaying){
    window.dataLayer.push({
      eventCategory: 'video',
      eventAction: 'clicVideo',
      eventLabel: 'jouerVideo',
      event: 'genericGAEvent'
    });

    console.log("jouer video");
  }

}

openList(e){
  this.setState({showingList:true});

  window.dataLayer.push({
    eventCategory: 'video',
    eventAction: 'clicInterne',
    eventLabel: 'ouvrirListe',
    event: 'genericGAEvent'
  });
}

closeList(){
  this.setState({showingList:false});

  window.dataLayer.push({
    eventCategory: 'video',
    eventAction: 'clicInterne',
    eventLabel: 'fermerListe',
    event: 'genericGAEvent'
  });

}

shareAlternative(){
  this.setState({shareAlternative: true});
}

closeShareAlternative(){
  this.setState({shareAlternative: false});
}

handleMute(){
  if(this.state.isMuted){
    this.engine.setVolume(1);

    window.dataLayer.push({
      eventCategory: 'video',
      eventAction: 'clicInteraction',
      eventLabel: 'ouvrirSon',
      event: 'genericGAEvent'
    });

  }else{
    this.engine.setVolume(0);

    window.dataLayer.push({
      eventCategory: 'video',
      eventAction: 'clicInteraction',
      eventLabel: 'fermerSon',
      event: 'genericGAEvent'
    });
  }
  this.setState({isMuted: !this.state.isMuted});
}

handleBack(e){
  this.engine.stop()
  let encodedItems = this.props.query.location.search.substring(1);
  this.props.query.push('/?' + encodedItems);
  console.log(this.props.query);
}

render() {

    return(
      <React.Fragment>
        <MainLogo handler={this.handleBack} firstTime={this.props.firstTime}/>
        {!this.state.loaded && <Loader/>}
        <div style={{visibility:this.state.loaded ? "visible" : "hidden"}}>
          <ContentPlayer  query={this.props.query}
                          stopper={this.engine.stop}
                          handler={this.handlePlay}
                          pauser={this.handlePause}
                          isPlaying={this.state.videoPlaying}
                          progress={this.state.progress}
                          duration={this.engine.totalDuration}
                          openList={this.openList}
                          shareAlternative={this.shareAlternative}
                          isMuted={this.state.isMuted}
                          mute={this.handleMute}/>
        </div>
        {this.state.showingList &&
          <PlayerList items={this.state.choosenItems} closeList={this.closeList}/>
        }
        {this.state.shareAlternative &&
          <ShareAlternative close={this.closeShareAlternative}/>
        }
     </React.Fragment>
    )
  }
}

export default Player;

//    return <List key={0} content={this.state.query} dataListe={this.state.json}/>;

//    <MainLogo/>
